import React from "react";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import { compose } from "recompose";
import InlineAlert from "theme/components/molecules/Alert/InlineAlert";

const makeCommandDispatcherWithMessageFeedback = (
  handlers,
  shouldHandleMessage = true
) =>
  compose(
    makeCommandDispatcher(handlers),
    (BaseComponent) =>
      ({ hasMessage, message, success, ...props }) => {
        props = Object.assign(
          {},
          props,
          shouldHandleMessage ? {} : { hasError: !success, message }
        );

        if (!shouldHandleMessage) {
          return <BaseComponent {...props} />;
        }

        return (
          <>
            {hasMessage && shouldHandleMessage ? (
              success ? (
                <InlineAlert appearance="success">{message}</InlineAlert>
              ) : (
                <InlineAlert appearance="error">{message}</InlineAlert>
              )
            ) : null}
            <BaseComponent {...props} />
          </>
        );
      }
  );

export default makeCommandDispatcherWithMessageFeedback;
